import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { makeStyles, useTheme, withStyles } from "@material-ui/core/styles";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableFooter from "@material-ui/core/TableFooter";
import TablePagination from "@material-ui/core/TablePagination";
import TableRow from "@material-ui/core/TableRow";
import Paper from "@material-ui/core/Paper";
import IconButton from "@material-ui/core/IconButton";
import TableHead from "@material-ui/core/TableHead";
import FirstPageIcon from "@material-ui/icons/FirstPage";
import KeyboardArrowLeft from "@material-ui/icons/KeyboardArrowLeft";
import KeyboardArrowRight from "@material-ui/icons/KeyboardArrowRight";
import LastPageIcon from "@material-ui/icons/LastPage";
import TableSftoAndGpwisSkeleton from "./TableSftoAndGpwisSkeleton";
// import { default as Apiservices } from "../../../../common";

const useStyles1 = makeStyles((theme) => ({
    root: {
        flexShrink: 0,
        marginLeft: theme.spacing(0),
    },
}));

function TablePaginationActions(props) {
    const classes = useStyles1();
    const theme = useTheme();
    const { count, page, rowsPerPage, onChangePage } = props;

    const handleFirstPageButtonClick = (event) => {
        onChangePage(event, 0);
    };

    const handleBackButtonClick = (event) => {
        onChangePage(event, page - 1);
    };

    const handleNextButtonClick = (event) => {
        onChangePage(event, page + 1);
    };

    const handleLastPageButtonClick = (event) => {
        onChangePage(event, Math.max(0, Math.ceil(count / rowsPerPage) - 1));
    };

    return (
        <div className={classes.root}>
            <IconButton
                onClick={handleFirstPageButtonClick}
                disabled={page === 0}
                aria-label="first page"
            >
                {theme.direction === "rtl" ? <LastPageIcon /> : <FirstPageIcon />}
            </IconButton>
            <IconButton
                onClick={handleBackButtonClick}
                disabled={page === 0}
                aria-label="previous page"
            >
                {theme.direction === "rtl" ? (
                    <KeyboardArrowRight />
                ) : (
                    <KeyboardArrowLeft />
                )}
            </IconButton>
            <IconButton
                onClick={handleNextButtonClick}
                disabled={page >= Math.ceil(count / rowsPerPage) - 1}
                aria-label="next page"
            >
                {theme.direction === "rtl" ? (
                    <KeyboardArrowLeft />
                ) : (
                    <KeyboardArrowRight />
                )}
            </IconButton>
            <IconButton
                onClick={handleLastPageButtonClick}
                disabled={page >= Math.ceil(count / rowsPerPage) - 1}
                aria-label="last page"
            >
                {theme.direction === "rtl" ? <FirstPageIcon /> : <LastPageIcon />}
            </IconButton>
        </div>
    );
}

TablePaginationActions.propTypes = {
    count: PropTypes.number.isRequired,
    onChangePage: PropTypes.func.isRequired,
    page: PropTypes.number.isRequired,
    rowsPerPage: PropTypes.number.isRequired,
};

const getCommodityById = (commodityId) => {
    //console.log(commodityId);
    return commodityId;
}

function createData(name, calories, fat) {
    return { name, calories, fat };
}

// const rows = [
//   createData("Cupcake", 305, 3.7),
//   createData("Donut", 452, 25.0),
//   createData("Eclair", 262, 16.0),
//   createData("Frozen yoghurt", 159, 6.0),
//   createData("Gingerbread", 356, 16.0),
//   createData("Honeycomb", 408, 3.2),
//   createData("Ice cream sandwich", 237, 9.0),
//   createData("Jelly Bean", 375, 0.0),
//   createData("KitKat", 518, 26.0),
//   createData("Lollipop", 392, 0.2),
//   createData("Marshmallow", 318, 0),
//   createData("Nougat", 360, 19.0),
//   createData("Oreo", 437, 18.0),
// ].sort((a, b) => (a.calories < b.calories ? -1 : 1));

const useStyles2 = makeStyles({
    table: {
        minWidth: "100%",
        whiteSpace: "nowrap"
    },
    toobarBgColor: {
        "& .MuiToolbar-regular": {
            background: "#fff",
        },
    },
    container: {
        maxHeight: "340px",
        minHeight: "340px",
        overflowY: "hidden",
        "&:hover": {
            overflowY: "auto",
            "&::-webkit-scrollbar": {
                width: "4px",
            },

            /* Track */

            "&::-webkit-scrollbar-track": {
                background: "#fff",
            },

            /* Handle */

            "&::-webkit-scrollbar-thumb": {
                backgroundColor: "#d4d8da",
                borderRadius: "20px",
                // border: "3px solid orange",
            },

            /* Handle on hover */

            "&::-webkit-scrollbar-thumb:hover": {
                background: "",
            },
        },
    },
});
const StyledTableCell = withStyles((theme) => ({
    head: {
        backgroundColor: theme.palette.common.white,
        color: theme.palette.primary.main,
    },
    body: {
        fontSize: 14,
    },
}))(TableCell);

export default function TableSftoJobDetailsComponent(props) {
    const classes = useStyles2();
    const [page, setPage] = React.useState(0);
    // let array = [{ invoicedate: "1", count: "1" }];
    const [array, setArray] = React.useState([
        { invoicedate: "No Data", count: "No Data" },
    ]);

    const [loading, setLoading] = React.useState(true);

    const [rowsPerPage, setRowsPerPage] = React.useState(5);
    useEffect(() => {
        setLoading(props.loading);
        if (props.allSftoJobDetails) {
            //   
            // let fetch = async () => {
            //     const commodityList = await Apiservices.commodityList();
            //     //console.log(commodityList);
            //       
            // }
            // fetch();
            setArray(props.allSftoJobDetails);

        } else {
            setArray([{
                createdate: "No Data",
                job_id: "No Data",
                rake_name: "No Data",
                rake_type: "No Data",
                origin: "No Data",
                origin_code: "No Data",
                destination: "No Data",
                destination_code: "No Data",
                advance_requistion_date: "No Data",
                rake_arrival_at_yard_date_time: "No Data",
                railways_insp_strt_time: "No Data",
                railways_insp_end_time: "No Data",
                offered_to_customer_by_tmill_or_railways: "No Data",
                made_over_date_time: "No Data",
                arrival_at_plant_date_time: "No Data",
                rake_placement_time: "No Data",
                loading_start_time: "No Data",
                loading_end_time: "No Data",
                offered_to_railways_date_time: "No Data",
                draw_out_date_time: "No Data",
                rr_no: "No Data",
                rr_date: "No Data",
                rr_actual_weight: "No Data",
                rr_chargeable_weight: "No Data",
                rr_amount: "No Data",
                rebate_amount: "No Data",
                loco_allotment_datetime: "No Data",
                eot_datetime: "No Data",
                rake_departure_datetime: "No Data",
                actual_arrival_at_destination_date_time: "No Data",
                destination_rake_placement_datetime: "No Data",
                unloading_start_date_time: "No Data",
                unloading_end_date_time: "No Data",
                return_departure_date_time: "No Data",
                return_arrival_date_time: "No Data",
                commodity: "No Data"
            }]);
        }

        // setArray(props.allSftoJobDetails);
    }, [props]);
    const emptyRows =
        rowsPerPage - Math.min(rowsPerPage, array.length - page * rowsPerPage);

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

    return (
        <div>
            <TableContainer component={Paper} className={classes.container}>
                <Table
                    className={classes.table}
                    aria-label="simple table"
                    stickyHeader
                >
                    {loading ? (
                        <TableSftoAndGpwisSkeleton />
                    ) : (
                        <>
                            <TableHead>
                                <TableRow>
                                    <StyledTableCell style={{fontWeight: 'bold'}} align="center">
                                        Job Created Date
                                    </StyledTableCell>
                                    <StyledTableCell align="center">
                                        <b>Job ID</b>
                                    </StyledTableCell>
                                    <StyledTableCell align="center">
                                        <b>Rake Name</b>
                                    </StyledTableCell>
                                    <StyledTableCell align="center">
                                        <b>Rake Type</b>
                                    </StyledTableCell>
                                    <StyledTableCell align="center">
                                        <b>Origin</b>
                                    </StyledTableCell>
                                    <StyledTableCell align="center">
                                        <b>Origin Code</b>
                                    </StyledTableCell>
                                    <StyledTableCell align="center">
                                        <b>Destination</b>
                                    </StyledTableCell>
                                    <StyledTableCell align="center">
                                        <b>Destination Code</b>
                                    </StyledTableCell>
                                    <StyledTableCell align="center">
                                        <b>Advance Paid Date</b>
                                    </StyledTableCell>
                                    <StyledTableCell align="center">
                                        <b>Rake Arrival at Yard Date/Time</b>
                                    </StyledTableCell>
                                    <StyledTableCell align="center">
                                        <b>Railways Inspection Start Date/Time</b>
                                    </StyledTableCell>
                                    <StyledTableCell align="center">
                                        <b>Railways Inspection End Date/Time</b>
                                    </StyledTableCell>
                                    <StyledTableCell align="center">
                                        <b>Offered to Customer</b>
                                    </StyledTableCell>
                                    <StyledTableCell align="center">
                                        <b>Made Over Date Time</b>
                                    </StyledTableCell>
                                    <StyledTableCell align="center">
                                        <b>Arrival at Plant Date Time</b>
                                    </StyledTableCell>
                                    <StyledTableCell align="center">
                                        <b>Rake Placement Date Time</b>
                                    </StyledTableCell>
                                    <StyledTableCell align="center">
                                        <b>Loading Start Date Time</b>
                                    </StyledTableCell>
                                    <StyledTableCell align="center">
                                        <b>Loading End Date Time</b>
                                    </StyledTableCell>
                                    <StyledTableCell align="center">
                                        <b>Offered to Railways</b>
                                    </StyledTableCell>
                                    <StyledTableCell align="center">
                                        <b>Drawout Date Time</b>
                                    </StyledTableCell>
                                    <StyledTableCell align="center">
                                        <b>RR No.</b>
                                    </StyledTableCell>
                                    <StyledTableCell align="center">
                                        <b>RR Date</b>
                                    </StyledTableCell>
                                    <StyledTableCell align="center">
                                        <b>RR Chargeable Weight</b>
                                    </StyledTableCell>
                                    <StyledTableCell align="center">
                                        <b>RR Actual Weight</b>
                                    </StyledTableCell>
                                    <StyledTableCell align="center">
                                        <b>RR Amount</b>
                                    </StyledTableCell>
                                    <StyledTableCell align="center">
                                        <b>Rebate Amount</b>
                                    </StyledTableCell>
                                    <StyledTableCell align="center">
                                        <b>Loco Allotment Date Time</b>
                                    </StyledTableCell>
                                    <StyledTableCell align="center">
                                        <b>Engine on Train Date Time</b>
                                    </StyledTableCell>
                                    <StyledTableCell align="center">
                                        <b>Rake Departure Date Time</b>
                                    </StyledTableCell>
                                    <StyledTableCell align="center">
                                        <b>Actual Arrival at Destination Date Time</b>
                                    </StyledTableCell>
                                    <StyledTableCell align="center">
                                        <b>Rake Placement Date Time</b>
                                    </StyledTableCell>
                                    <StyledTableCell align="center">
                                        <b>Unloading Start Date Time</b>
                                    </StyledTableCell>
                                    <StyledTableCell align="center">
                                        <b>Unloading End Date Time</b>
                                    </StyledTableCell>
                                    <StyledTableCell align="center">
                                        <b>Return Departure Date Time</b>
                                    </StyledTableCell>
                                    <StyledTableCell align="center">
                                        <b>Rake Arrival Date Time</b>
                                    </StyledTableCell>
                                    <StyledTableCell align="center">
                                        <b>Commodity</b>
                                    </StyledTableCell>
                                    <StyledTableCell align="center">
                                        <b>Special Instructions</b>
                                    </StyledTableCell>
                                </TableRow>
                            </TableHead>

                            <TableBody>
                                {(rowsPerPage > 0
                                    ? array.slice(
                                        page * rowsPerPage,
                                        page * rowsPerPage + rowsPerPage
                                    )
                                    : array
                                ).map((row,index) => (
                                    <TableRow key={index}>
                                        <TableCell align="center">
                                            <>
                                                {
                                                    row.createdate ? (
                                                        <b>{row.createdate}</b>
                                                    ) : (
                                                        <b>-</b>
                                                    )
                                                }

                                            </>
                                        </TableCell>
                                        <TableCell align="center">
                                            <div>
                                                {
                                                    row.job_id ? (
                                                        <b>{row.job_id}</b>
                                                    ) : (
                                                        <b>-</b>
                                                    )
                                                }

                                            </div>

                                        </TableCell>
                                        <TableCell align="center">
                                            <div>
                                                {
                                                    row.rake_name ? (
                                                        <b>{row.rake_name}</b>
                                                    ) : (
                                                        <b>-</b>
                                                    )
                                                }

                                            </div>

                                        </TableCell>
                                        <TableCell align="center">
                                            <div>
                                                {
                                                    row.rake_type ? (
                                                        <b>{row.rake_type}</b>
                                                    ) : (
                                                        <b>-</b>
                                                    )
                                                }

                                            </div>

                                        </TableCell>
                                        <TableCell align="center">
                                            <div>
                                                {
                                                    row.origin ? (
                                                        <b>{row.origin}</b>
                                                    ) : (
                                                        <b>-</b>
                                                    )
                                                }

                                            </div>

                                        </TableCell>
                                        <TableCell align="center">
                                            <div>
                                                {
                                                    row.origin_code ? (
                                                        <b>{row.origin_code}</b>
                                                    ) : (
                                                        <b>-</b>
                                                    )
                                                }

                                            </div>

                                        </TableCell>
                                        <TableCell align="center">
                                            <div>
                                                {
                                                    row.destination ? (
                                                        <b>{row.destination}</b>
                                                    ) : (
                                                        <b>-</b>
                                                    )
                                                }

                                            </div>

                                        </TableCell>
                                        <TableCell align="center">
                                            <div>
                                                {
                                                    row.destination_code ? (
                                                        <b>{row.destination_code}</b>
                                                    ) : (
                                                        <b>-</b>
                                                    )
                                                }

                                            </div>

                                        </TableCell>
                                        <TableCell align="center">
                                            <div>
                                                {
                                                    row.advance_requistion_date ? (
                                                        <b>{row.advance_requistion_date}</b>
                                                    ) : (
                                                        <b>-</b>
                                                    )
                                                }

                                            </div>

                                        </TableCell>
                                        <TableCell align="center">
                                            <div>
                                                {
                                                    row.rake_arrival_at_yard_date_time ? (
                                                        <b>{row.rake_arrival_at_yard_date_time}</b>
                                                    ) : (
                                                        <b>-</b>
                                                    )
                                                }

                                            </div>

                                        </TableCell>
                                        <TableCell align="center">
                                            <div>
                                                {
                                                    row.railways_insp_strt_time ? (
                                                        <b>{row.railways_insp_strt_time}</b>
                                                    ) : (
                                                        <b>-</b>
                                                    )
                                                }

                                            </div>

                                        </TableCell>
                                        <TableCell align="center">
                                            <div>
                                                {
                                                    row.railways_insp_end_time ? (
                                                        <b>{row.railways_insp_end_time}</b>
                                                    ) : (
                                                        <b>-</b>
                                                    )
                                                }

                                            </div>

                                        </TableCell>
                                        <TableCell align="center">
                                            <div>
                                                {
                                                    row.offered_to_customer_by_tmill_or_railways ? (
                                                        <b>{row.offered_to_customer_by_tmill_or_railways}</b>
                                                    ) : (
                                                        <b>-</b>
                                                    )
                                                }

                                            </div>

                                        </TableCell>
                                        <TableCell align="center">
                                            <div>
                                                {
                                                    row.made_over_date_time ? (
                                                        <b>{row.made_over_date_time}</b>
                                                    ) : (
                                                        <b>-</b>
                                                    )
                                                }

                                            </div>

                                        </TableCell>
                                        <TableCell align="center">
                                            <div>
                                                {
                                                    row.arrival_at_plant_date_time ? (
                                                        <b>{row.arrival_at_plant_date_time}</b>
                                                    ) : (
                                                        <b>-</b>
                                                    )
                                                }

                                            </div>

                                        </TableCell>
                                        <TableCell align="center">
                                            <div>
                                                {
                                                    row.rake_placement_time ? (
                                                        <b>{row.rake_placement_time}</b>
                                                    ) : (
                                                        <b>-</b>
                                                    )
                                                }

                                            </div>

                                        </TableCell>
                                        <TableCell align="center">
                                            <div>
                                                {
                                                    row.loading_start_time ? (
                                                        <b>{row.loading_start_time}</b>
                                                    ) : (
                                                        <b>-</b>
                                                    )
                                                }

                                            </div>

                                        </TableCell>
                                        <TableCell align="center">
                                            <div>
                                                {
                                                    row.loading_end_time ? (
                                                        <b>{row.loading_end_time}</b>
                                                    ) : (
                                                        <b>-</b>
                                                    )
                                                }

                                            </div>

                                        </TableCell>
                                        <TableCell align="center">
                                            <div>
                                                {
                                                    row.offered_to_railways_date_time ? (
                                                        <b>{row.offered_to_railways_date_time}</b>
                                                    ) : (
                                                        <b>-</b>
                                                    )
                                                }

                                            </div>

                                        </TableCell>
                                        <TableCell align="center">
                                            <div>
                                                {
                                                    row.draw_out_date_time ? (
                                                        <b>{row.draw_out_date_time}</b>
                                                    ) : (
                                                        <b>-</b>
                                                    )
                                                }

                                            </div>

                                        </TableCell>
                                        <TableCell align="center">
                                            <div>
                                                {
                                                    row.rr_no ? (
                                                        <b>{row.rr_no}</b>
                                                    ) : (
                                                        <b>-</b>
                                                    )
                                                }

                                            </div>

                                        </TableCell>
                                        <TableCell align="center">
                                            <div>
                                                {
                                                    row.rr_date ? (
                                                        <b>{row.rr_date}</b>
                                                    ) : (
                                                        <b>-</b>
                                                    )
                                                }

                                            </div>

                                        </TableCell>
                                        <TableCell align="center">
                                            <div>
                                                {
                                                    row.rr_chargeable_weight ? (
                                                        <b>{row.rr_chargeable_weight}</b>
                                                    ) : (
                                                        <b>-</b>
                                                    )
                                                }

                                            </div>

                                        </TableCell>
                                        <TableCell align="center">
                                            <div>
                                                {
                                                    row.rr_actual_weight ? (
                                                        <b>{row.rr_actual_weight}</b>
                                                    ) : (
                                                        <b>-</b>
                                                    )
                                                }

                                            </div>

                                        </TableCell>
                                        <TableCell align="center">
                                            <div>
                                                {
                                                    row.rr_amount ? (
                                                        <b>{row.rr_amount}</b>
                                                    ) : (
                                                        <b>-</b>
                                                    )
                                                }

                                            </div>

                                        </TableCell>
                                        <TableCell align="center">
                                            <div>
                                                {
                                                    row.rebate_amount ? (
                                                        <b>{row.rebate_amount}</b>
                                                    ) : (
                                                        <b>-</b>
                                                    )
                                                }

                                            </div>

                                        </TableCell>
                                        <TableCell align="center">
                                            <div>
                                                {
                                                    row.loco_allotment_datetime ? (
                                                        <b>{row.loco_allotment_datetime}</b>
                                                    ) : (
                                                        <b>-</b>
                                                    )
                                                }

                                            </div>

                                        </TableCell>
                                        <TableCell align="center">
                                            <div>
                                                {
                                                    row.eot_datetime ? (
                                                        <b>{row.eot_datetime}</b>
                                                    ) : (
                                                        <b>-</b>
                                                    )
                                                }

                                            </div>

                                        </TableCell>
                                        <TableCell align="center">
                                            <div>
                                                {
                                                    row.rake_departure_datetime ? (
                                                        <b>{row.rake_departure_datetime}</b>
                                                    ) : (
                                                        <b>-</b>
                                                    )
                                                }

                                            </div>

                                        </TableCell>
                                        <TableCell align="center">
                                            <div>
                                                {
                                                    row.actual_arrival_at_destination_date_time ? (
                                                        <b>{row.actual_arrival_at_destination_date_time}</b>
                                                    ) : (
                                                        <b>-</b>
                                                    )
                                                }

                                            </div>

                                        </TableCell>
                                        <TableCell align="center">
                                            <div>
                                                {
                                                    row.destination_rake_placement_datetime ? (
                                                        <b>{row.destination_rake_placement_datetime}</b>
                                                    ) : (
                                                        <b>-</b>
                                                    )
                                                }

                                            </div>

                                        </TableCell>
                                        <TableCell align="center">
                                            <div>
                                                {
                                                    row.unloading_start_date_time ? (
                                                        <b>{row.unloading_start_date_time}</b>
                                                    ) : (
                                                        <b>-</b>
                                                    )
                                                }

                                            </div>

                                        </TableCell>
                                        <TableCell align="center">
                                            <div>
                                                {
                                                    row.unloading_end_date_time ? (
                                                        <b>{row.unloading_end_date_time}</b>
                                                    ) : (
                                                        <b>-</b>
                                                    )
                                                }

                                            </div>

                                        </TableCell>
                                        <TableCell align="center">
                                            <div>
                                                {
                                                    row.return_departure_date_time ? (
                                                        <b>{row.return_departure_date_time}</b>
                                                    ) : (
                                                        <b>-</b>
                                                    )
                                                }

                                            </div>

                                        </TableCell>
                                        <TableCell align="center">
                                            <div>
                                                {
                                                    row.return_arrival_date_time ? (
                                                        <b>{row.return_arrival_date_time}</b>
                                                    ) : (
                                                        <b>-</b>
                                                    )
                                                }

                                            </div>

                                        </TableCell>
                                        <TableCell align="center">
                                            <div>
                                                {
                                                    row.commodity ? (
                                                        <b>{row.commodity}</b>
                                                    ) : (
                                                        <b>-</b>
                                                    )
                                                }

                                            </div>

                                        </TableCell>
                                        <TableCell align="center">
                                            <div>
                                                {
                                                    row.special_instructions ? (
                                                        <b>{row.special_instructions}</b>
                                                    ) : (
                                                        <b>-</b>
                                                    )
                                                }

                                            </div>

                                        </TableCell>
                                    </TableRow>
                                ))}
                            </TableBody>


                            <TableFooter>
                                <TableRow></TableRow>
                            </TableFooter>
                        </>
                    )}
                </Table>
            </TableContainer>
            <TableContainer>
                <TablePagination
                    className={classes.toobarBgColor}
                    rowsPerPageOptions={[5, 10, 25, { label: "All", value: -1 }]}
                    component="div"
                    count={array.length}
                    rowsPerPage={rowsPerPage}
                    page={page}
                    SelectProps={{
                        inputProps: { "aria-label": "rows per page" },
                        native: true,
                    }}
                    onChangePage={handleChangePage}
                    onChangeRowsPerPage={handleChangeRowsPerPage}
                    ActionsComponent={TablePaginationActions}
                />
            </TableContainer>
        </div >
    )
}
